function resetPositions({ board, buttons }) {
  board.classList.forEach((cls) => {
    board.classList.remove(cls);
  })
  board.classList.add("board");
  board.classList.add("composite-transform");
  board.style = "";
  buttons.forEach((button) => {
    button.style.position = "";
    button.style.transform = "";
  })
}

export default resetPositions;
